<template>
  <div class="planList">
    <p class="title">方案列表</p>
    <!-- 顶部功能按钮及筛选项 -->
    <div class="toolbar">
      <!-- 按钮 -->
      <el-row type="flex">
        <el-col :lg="6">
          <label>患者姓名:</label>
          <el-input placeholder="请输入患者姓名" v-model="patientName" class="input-with-select"
            @keyup.enter.native='getPlanPageList'>
            <el-button slot="append" icon="el-icon-search" @click="getPlanPageList"></el-button>
          </el-input>
        </el-col>
        <el-col :lg="6">
          <label>关键字:</label>
          <el-input placeholder="请输入关键字" v-model="keyword" class="input-with-select"
            @keyup.enter.native='getPlanPageList'>
            <el-button slot="append" icon="el-icon-search" @click="getPlanPageList"></el-button>
          </el-input>
        </el-col>
        <el-col :lg="6">
          <label>方案类型:</label>
          <el-select v-model="type" placeholder="请选择" @change="getPlanPageList" class="color-select">
            <el-option key="" label="全部" value=""></el-option>
            <el-option :key="0" label="专科方案" :value="0"></el-option>
            <el-option :key="1" label="汇总方案" :value="1"></el-option>
            <el-option :key="2" label="待汇总方案" :value="2"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- 表 -->
    <div class="content">

      <el-table class="table-simple" :data="tableData" style="width: 100%" header-row-class-name="headclass">
        <el-table-column prop="id" label="ID" align="center">
        </el-table-column>
        <el-table-column prop="patientName" label="患者姓名" align="center">
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="conclusion" label="总结" align="center">
        </el-table-column>
        <el-table-column prop="plan" label="方案" align="center">
        </el-table-column>
        <el-table-column prop="userMobile" label="会员手机号" align="center">
        </el-table-column>
        <el-table-column prop="dorMobile" label="医生手机号" align="center">
        </el-table-column>
        <el-table-column prop="inventory" label="方案类型" align="center">
          <template slot-scope="scope">
            <p v-if='scope.row.type==0'>专科方案</p>
            <p v-if='scope.row.type==1'>汇总方案</p>
            <p v-if='scope.row.type==2'>待汇总方案</p>
            <p v-if='scope.row.type==3'>已汇总方案</p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center">
        </el-table-column>
        <el-table-column prop="handle" label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <a class="txt-btn btn-yellow" v-if='scope.row.ownStatus==1&&scope.row.type!=3' @click="handelEdit(scope.row)">编辑</a>
            <a class="txt-btn btn-yellow" v-else style="color:#ccc">编辑</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
        layout="total,prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 方案1 -->
    <el-dialog title="编辑方案" :visible.sync="fanganvisable" class="fangandia" @close="closefaDialog"
      :modal-append-to-body="false">
      <!-- <p>于2019-11-19 13:00:00提交</p> -->
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="患者姓名:">
              {{form.patientName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属小组:">
              {{form.groupName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="方案标题:">
              <el-input v-model="form.title" placeholder='请输入方案标题'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="总结:">
              <el-input v-model="form.conclusion" placeholder='请输入总结'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体方案:">
              <el-input v-model="form.plan" type="textarea" placeholder='请输入具体方案'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交时间:">
              {{form.updateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-btn" type="primary" @click="editPlan()">确 定
        </el-button>
        <el-button @click="closefaDialog">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 方案2 -->
    <el-dialog title="编辑方案" :visible.sync="fangan1visable" @close="closefa1Dialog" :modal-append-to-body="false">
      <!-- <p>于2019-11-19 13:00:00提交</p> -->
      <el-form ref="form" :model="form1" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="患者姓名:">
              {{form1.patientName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属小组:">
              {{form1.patientName}}
            </el-form-item>
          </el-col>
        </el-row>
        <p class="title" style="font-size:20px;">汇总方案</p>
        <el-table class="table-simple" :data="tableData1" style="width: 100%;margin-bottom:20px;">
          <el-table-column prop="title" label="方案标题" align="center">
          </el-table-column>
          <el-table-column prop="conclusion" label="总结" align="center">
          </el-table-column>
          <el-table-column prop="plan" label="方案" align="center">
          </el-table-column>
          <el-table-column prop="dorName" label="提交医生" align="center">
          </el-table-column>
          <el-table-column prop="departmentName" label="医生科室" align="center">
          </el-table-column>
          <el-table-column prop="updateTime" label="提交时间" align="center">
          </el-table-column>
          <el-table-column prop="handle" label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <!-- 编辑 -->
              <a class="txt-btn btn-yellow" v-if='scope.row.ownStatus==1&&scope.row.type!=3' @click="handelEdit1(scope.row)">编辑</a>
              <a class="txt-btn btn-yellow" v-else style="color:#ccc">编辑</a>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <el-form-item label="方案标题:">
              <el-input v-model="form1.title" placeholder='请输入方案标题'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="总结:">
              <el-input v-model="form1.conclusion" placeholder='请输入总结'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="具体方案:">
              <el-input v-model="form1.plan" type="textarea" placeholder='请输入具体方案'>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交时间:">
              {{form1.updateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-btn" type="primary" @click="editPlan()">确 定
        </el-button>
        <el-button @click="closefa1Dialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  // 接口引用
  import {
    getPlanPageList,
    editPlan,
    getPlanInfo,
    getRelPlans
  } from "@/api/getData";
  import {} from "@/config/validform";
  export default {
    // 变量定义
    data() {
      return {
        tableData: [],
        tableData1: [],
        currentPage: 1,
        total: 0,
        fanganvisable: false,
        fangan1visable: false,
        form: {},
        form1: {},
        patientName: '',
        keyword: '',
        type: '',
        formtype: ''
      }
    },

    created() {
      this.getPlanPageList();
    },
    methods: {
      // 获取与汇总方案相关联的方案
      async getRelPlans(id) {
        var res = await getRelPlans({
          id: id
        });
        if (res.code == "0") {
          this.tableData1 = res.data
          this.fangan1visable = true;

        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 获取方案详情
      async getPlanInfo(id) {
        var res = await getPlanInfo({
          id: id
        });
        if (res.code == "0") {
          this.form1 = res.data
          this.getRelPlans(id);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      // 编辑方案
      async editPlan() {
        let subform = {};

        if (this.form.title == '') {
          this.$message({
            type: "error",
            message: '请输入方案标题'
          });
        } else if (this.form.conclusion == '') {
          this.$message({
            type: "error",
            message: '请输入总结'
          });
        } else if (this.form.plan == '') {
          this.$message({
            type: "error",
            message: '请输入方案'
          });
        } else {
          subform.id = this.form.id;
          subform.conclusion = this.form.conclusion;
          subform.plan = this.form.plan;
          subform.title = this.form.title;
          subform.submitType = this.formtype
          var res = await editPlan(subform);
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: '编辑成功'
            });
            this.closefaDialog();
            this.getPlanPageList();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        }



      },
      handelEdit(row) {
        this.formtype = row.type
        if (row.type == 1 || row.type == 3) {
          this.getPlanInfo(row.id);
        } else {
          let txt = JSON.stringify(row);
          this.form = JSON.parse(txt);
          this.fanganvisable = true;
        }

      },
      // handelEdit1(row) {

      //   let txt = JSON.stringify(row);
      //   this.form = JSON.parse(txt);
      //   this.fanganvisable = true;


      // },
      // 获取方案列表
      async getPlanPageList() {
        var res = await getPlanPageList({
          patientName: this.patientName,
          keyword: this.keyword,
          type: this.type,
          page: this.currentPage,
          rows: 10,
        });
        if (res.code == "0") {
          this.tableData = res.data.list
          this.total = res.data.totalCount
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      },
      closefaDialog() {
        this.fanganvisable = false
      },
      closefa1Dialog() {
        this.fangan1visable = false
      },
      //修改当前页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getPlanPageList();
      },
    }
  }

</script>
<style lang="less">
  .el-main {
    background-color: #f0f2f5;
  }

  .planList {
    width: 98%;
    float: left;
    margin: 1%;
    height: 96%;
    padding: 1%;
    background-color: #fff;

    .title {
      font-size: 25px;
      font-weight: 600;
      text-align: left
    }

    .content {
      width: 100%;
      height:85%
    }

    .headclass {

      tr,
      th {
        background-color: rgba(247, 247, 247, 1);
      }

    }

    .toolbar {
      width: 100%;
      float: left;
      margin-bottom: 30px;
    }

    .toolbar .el-row label {
      float: left;
      width: 20%;
      line-height: 40px;
      ;
    }

    .toolbar .el-row .el-input {
      float: left;
      width: 80%;
      height: 40px;
    }

    .toolbar .el-row .el-select {
      float: left;
      width: 80%;
      height: 40px;

      .el-input {
        width: 100%
      }
    }

    .page {
      text-align: right;
      padding: 20px 0
    }

    .fangandia {
      .el-dialog {
        width: 500px !important;

        // height: 400px;
        .el-dialog__body {
          padding-bottom: 0
        }
      }

      .el-form {
        width: 100%;
        margin-left: 0;
      }
    }

    .el-form-item__content {
      text-align: left;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/planList.vue